import axios from "axios";
import moment from "moment";
import { message } from "antd";
import * as COMMONS from "common/common";

export * from "../api/master";

export const SITE_URL = import.meta.env.VITE_APP_API_URL;
export const ZIP_CLOUD_SEARCH_URL =
	import.meta.env.VITE_ZIP_CLOUD_SEARCH_URL ||
	"https://zipcloud.ibsnet.co.jp/api/search";

export const BASE_URL = SITE_URL + "/api";
const UPLOADS_URL = SITE_URL + "/uploads";
export const LOTTERIES_UPLOADS_URL = UPLOADS_URL + "/lotteries/";
export const COUPONS_UPLOADS_URL = UPLOADS_URL + "/coupons/";
export const CATEGORIES_UPLOADS_URL = UPLOADS_URL + "/categories/";
export const OCCASIONS_UPLOADS_URL = UPLOADS_URL + "/occasions/";
export const MEMBERS_UPLOADS_URL = UPLOADS_URL + "/members/";
export const SETTINGS_UPLOADS_URL = UPLOADS_URL + "/settings/";
export const RICHMENUS_UPLOADS_URL = UPLOADS_URL + "/richmenus/";
export const SURVEYS_UPLOADS_URL = UPLOADS_URL + "/surveys/";
export const STAMPS_UPLOADS_URL = UPLOADS_URL + "/stampImages/";
export const POSTAL_CODE_URL =
	import.meta.env.VITE_POSTAL_CODE_URL ||
	"https://yubinbango.github.io/yubinbango-data/data";
export const PUBLIC_HOLIDAY_URL =
	import.meta.env.VITE_PUBLIC_HOLIDAY_URL ||
	"https://holidays-jp.github.io/api/v1/date.json";

/* BACKEND API URLS */
export const API_ADMIN_CHECK_SESSION = BASE_URL + "/sess";
export const API_ADMIN_LOGIN = BASE_URL + "/login";
export const API_ADMIN_LOGOUT = BASE_URL + "/logout";
export const API_ADMIN_AUTH = BASE_URL + "/auth";
export const API_ADMIN_DAILY_STATS = BASE_URL + "/m/dailyStats";
export const API_ADMIN_OCCASIONS = BASE_URL + "/m/occasions";
export const API_ADMIN_GIFTS = BASE_URL + "/m/gifts";
export const API_ADMIN_CAMPAIGN_GIFTS = BASE_URL + "/m/campaign-gifts";
export const API_ADMIN_OCCURRENCES = BASE_URL + "/m/occurrences";
export const API_ADMIN_CATEGORIES = BASE_URL + "/m/categories";
export const API_ADMIN_REGISTRATIONS = BASE_URL + "/m/registrations";
export const API_ADMIN_CAMPAIGN_REGISTRATIONS =
	BASE_URL + "/m/campaign-registrations";
export const API_ADMIN_HISTORY_REGISTRATIONS = BASE_URL + "/m/attended";
export const API_ADMIN_HISTORY_CAMPAIGNS_REGISTRATIONS =
	BASE_URL + "/m/campaigns-attended";
export const API_ADMIN_MEMBERS = BASE_URL + "/m/members";
export const API_ADMIN_INFLOW_SOURCE = BASE_URL + "/m/inflow-source";
export const API_ADMIN_CHATS = BASE_URL + "/m/members/chats";
export const API_ADMIN_SETTINGS = BASE_URL + "/m/settings";
export const API_ADMIN_RICHMENUS = BASE_URL + "/m/richmenus";
export const API_ADMIN_CAMPAIGNS = BASE_URL + "/m/campaigns";
export const API_ADMIN_AUDIENCES = BASE_URL + "/m/audiences";
export const API_ADMIN_CAMPAIGN_AUDIENCES = BASE_URL + "/m/audiences-campaign";
export const API_ADMIN_SPECTATORS = BASE_URL + "/m/spectators";
export const API_ADMIN_CUSTOMER_REGISTRATION =
	BASE_URL + "/m/settings-customer-registration";
export const API_CLIENT = BASE_URL + "/liff";
export const API_LIFF_SURVEYS = API_CLIENT + "/surveys";
export const API_LIFF_SURVEY_TEMPLATES = API_CLIENT + "/surveyTemplates";
export const API_LIFF_SURVEY_RECORDS = API_CLIENT + "/surveyRecords";

export const API_ADMIN_APP_SURVEYS = BASE_URL + "/app/surveys";
export const API_ADMIN_APP_SURVEY_TEMPLATES = BASE_URL + "/app/surveyTemplates";
export const API_ADMIN_APP_SURVEY_RECORDS = BASE_URL + "/app/surveyRecords";
export const API_ADMIN_APP_STATISTICS = API_ADMIN_APP_SURVEY_RECORDS + "/sum";
export const API_ADMIN_APP_STATISTICS_ONE =
	API_ADMIN_APP_SURVEY_RECORDS + "/total";

export const API_CLIENT_PAYMENT_KEY = API_CLIENT + "/payments/key";
export const API_CLIENT_VERITRANS_PAYMENT_KEY = "/veritrans/jp/pop/payment-key";
export const API_CLIENT_VERITRANS_REGISTER_GROUP =
	"/veritrans/jp/pop/register-group";
export const API_ADMIN_CAMPAIGN_LOTTERIES = BASE_URL + "/m/audiences-campaign";
export const API_ADMIN_LOTTERY_PRIZES = BASE_URL + "/m/audiences-campaign";

/* SOCKET PATH */
export const SOCKET_PATH = "/socket.io";

/* QUERY KEY */
export const QUERY_KEY_ADMIN_PUBLIC_SETTINGS = "ADMIN_PUBLIC_SETTINGS";
export const QUERY_KEY_ADMIN_CHECK_SESSION = "ADMIN_CHECK_SESSION";
export const QUERY_KEY_ADMIN_AUTH = "ADMIN_AUTH";
export const QUERY_KEY_ADMIN_DAILY_STATS = "ADMIN_DAILY_STATS";
export const QUERY_KEY_ADMIN_CATEGORY_TEMPLATES = "ADMIN_CATEGORY_TEMPLATES";
export const QUERY_KEY_ADMIN_CAMPAIGN_TEMPLATES = "ADMIN_CAMPAIGN_TEMPLATES";
export const QUERY_KEY_ADMIN_CAMPAIGN_TEMPLATE_DETAIL =
	"ADMIN_CAMPAIGN_TEMPLATE_DETAIL";
export const QUERY_KEY_ADMIN_CATEGORY_TEMPLATE_DETAIL =
	"ADMIN_CATEGORY_TEMPLATE_DETAIL";
export const QUERY_KEY_ADMIN_CATEGORY_TAGS = "ADMIN_CATEGORY_TAGS";
export const QUERY_KEY_ADMIN_CAMPAIGN_TAGS = "ADMIN_CAMPAIGN_TAGS";
export const QUERY_KEY_ADMIN_GIFT_TAGS = "ADMIN_GIFT_TAGS";
export const QUERY_KEY_ADMIN_CATEGORY_AREAS = "ADMIN_CATEGORY_AREAS";
export const QUERY_KEY_ADMIN_CATEGORIES = "ADMIN_CATEGORIES";
export const QUERY_KEY_ADMIN_CAMPAIGNS = "ADMIN_CAMPAIGNS";
export const QUERY_KEY_ADMIN_CATEGORY_LIST = "ADMIN_CATEGORY_LIST";
export const QUERY_KEY_ADMIN_CATEGORY_DETAIL = "ADMIN_CATEGORY_DETAIL";
export const QUERY_KEY_ADMIN_CAMPAIGN_DETAIL = "ADMIN_CAMPAIGN_DETAIL";
export const QUERY_KEY_ADMIN_OCCASIONS = "ADMIN_OCCASIONS";
export const QUERY_KEY_ADMIN_OCCASION_LIST = "ADMIN_OCCASION_LIST";
export const QUERY_KEY_ADMIN_OCCASION_DETAIL = "ADMIN_OCCASION_DETAIL";
export const QUERY_KEY_ADMIN_OCCASION_TAGS = "ADMIN_OCCASION_TAGS";
export const QUERY_KEY_ADMIN_OCCASION_TEMPLATES = "ADMIN_OCCASION_TEMPLATES";
export const QUERY_KEY_ADMIN_OCCASION_TEMPLATE_DETAIL =
	"OCCASION_TEMPLATE_DETAIL";
export const QUERY_KEY_ADMIN_GIFT_TEMPLATE_DETAIL = "GIFT_TEMPLATE_DETAIL";
export const QUERY_KEY_ADMIN_OCCURRENCE_DETAIL = "ADMIN_OCCURRENCE_DETAIL";
export const QUERY_KEY_ADMIN_CAMPAIGN_REGISTRATIONS =
	"ADMIN_CAMPAIGN_REGISTRATIONS";
export const QUERY_KEY_ADMIN_HISTORY_REGISTRATIONS =
	"ADMIN_GET_HISTORY_ATTENDED";
export const QUERY_KEY_ADMIN_HISTORY_CAMPAIGNS =
	"ADMIN_GET_HISTORY_CAMPAIGNS_ATTENDED";
export const QUERY_KEY_ADMIN_REGISTRATION_DETAIL = "ADMIN_REGISTRATION_DETAIL";
export const QUERY_KEY_ADMIN_MEMBERS = "ADMIN_MEMBERS";
export const QUERY_KEY_ADMIN_MEMBERS_LIST = "ADMIN_MEMBERS_LIST";
export const QUERY_KEY_ADMIN_MEMBER_DETAIL = "ADMIN_MEMBER_DETAIL";
export const QUERY_KEY_ADMIN_CHATS = "ADMIN_CHATS";
export const QUERY_KEY_ADMIN_RICHMENUS = "ADMIN_RICHMENUS";
export const QUERY_KEY_ADMIN_CAMPAIGN_QUESTIONS = "ADMIN_CAMPAIGN_QUESTIONS";
export const QUERY_KEY_ADMIN_SURVEYS = "ADMIN_SURVEYS";
export const QUERY_KEY_ADMIN_SURVEYS_STATISTICS = "ADMIN_SURVEYS_STATISTICS";
export const QUERY_KEY_ADMIN_SURVEYS_STATISTICS_ONE =
	"ADMIN_SURVEYS_STATISTICS_ONE";
export const QUERY_KEY_ADMIN_SURVEYS_TEMPLATE = "ADMIN_SURVEYS_TEMPLATE";
export const QUERY_KEY_ADMIN_CUSTOMER_REGISTRATIONS =
	"ADMIN_CUSTOMER_REGISTRATIONS";
export const QUERY_KEY_ADMIN_AUDIENCES = "ADMIN_AUDIENCES";
export const QUERY_KEY_ADMIN_CAMPAIGN_AUDIENCES = "ADMIN_CAMPAIGN_AUDIENCES";
export const QUERY_KEY_ADMIN_SPECTATORS = "ADMIN_SPECTATORS";
export const QUERY_KEY_ADMIN_SPECTATOR_CANDIDATES =
	"ADMIN_SPECTATOR_CANDIDATES";
export const QUERY_KEY_ADMIN_STAMPS = "ADMIN_STAMPS";
export const QUERY_KEY_CLIENT_STAMPS = "CLIENT_STAMPS";
export const QUERY_KEY_CLIENT_SCAN_STAMPS = "CLIENT_SCAN_STAMPS";
export const QUERY_KEY_CLIENT_PERSONAL_INFO = "CLIENT_PERSONAL_INFO";
export const QUERY_KEY_CLIENT_CAMPAIGN_QUESTIONS = "CLIENT_CAMPAIGN_QUESTIONS";
export const QUERY_KEY_CLIENT_CATEGORIES = "CLIENT_CATEGORIES";
export const QUERY_KEY_CLIENT_CAMPAIGNS = "CLIENT_CAMPAIGNS";
export const QUERY_KEY_CLIENT_CATEGORY_DETAIL = "CLIENT_CATEGORY_DETAIL";
export const QUERY_KEY_CLIENT_CAMPAIGN_DETAIL = "CLIENT_CAMPAIGN_DETAIL";
export const QUERY_KEY_CLIENT_OCCASIONS = "CLIENT_OCCASIONS";
export const QUERY_KEY_CLIENT_GIFTS = "CLIENT_GIFTS";
export const QUERY_KEY_CLIENT_OCCASION_DETAIL = "CLIENT_OCCASION_DETAIL";
export const QUERY_KEY_CLIENT_MY_REGISTRATIONS = "CLIENT_MY_REGISTRATIONS";
export const QUERY_KEY_CLIENT_MY_CAMPAIGN_REGISTRATIONS =
	"CLIENT_MY_CAMPAIGN_REGISTRATIONS";
export const QUERY_KEY_CLIENT_MY_REGISTRATION_DETAIL =
	"CLIENT_MY_REGISTRATION_DETAIL";
export const QUERY_KEY_CLIENT_MY_CAMPAIGN_REGISTRATION_DETAIL =
	"CLIENT_MY_CAMPAIGN_REGISTRATION_DETAIL";
export const QUERY_KEY_CLIENT_CUSTOMER_REGISTRATIONS =
	"CLIENT_CUSTOMER_REGISTRATIONS";
export const QUERY_KEY_LOGO = "LOGO";
export const QUERY_KEY_FAVICON = "FAVICON";
export const QUERY_KEY_STORE_PIC = "STORE_PIC";
export const QUERY_KEY_PUBLIC_SETTINGS = "PUBLIC_SETTINGS";
export const QUERY_KEY_PUBLIC_HOLIDAYS = "PUBLIC_HOLIDAYS";
export const QUERY_KEY_ZIP_CODE_SEARCH = "QUERY_KEY_ZIP_CODE_SEARCH";

/* SETTINGS KEY */
export const SETTINGS_KEY_SYSTEM_COLOR = "systemColor";
export const SETTINGS_KEY_SYSTEM_TITLE = "systemTitle";
export const SETTINGS_KEY_CLIENT_CATEGORIES_SCREEN_TITLE =
	"clientCategoriesScreenTitle";
export const SETTINGS_KEY_CLIENT_CATEGORIES_SCREEN_SUBTITLE =
	"clientCategoriesScreenSubtitle";
export const SETTINGS_KEY_ADMIN_INITIAL_RESERVABLE_COUNT =
	"adminInitialReservableCount";
export const SETTINGS_KEY_RESERVATION_CONFIRM_URL = "bookConfirmUrl";
export const SETTINGS_KEY_COMPANY_TELEPHONE = "companyTelephone";
export const SETTINGS_KEY_BOOK_LIMIT_ENABLED = "bookLimitEnabled";
export const SETTINGS_KEY_BOOK_LIMIT_DAY = "bookLimitDay";
export const SETTINGS_KEY_BOOK_LIMIT_HOUR = "bookLimitHour";
export const SETTINGS_KEY_BOOK_LIMIT_MINUTE = "bookLimitMinute";
export const SETTINGS_KEY_BOOK_CANCEL_ALLOWED = "bookCancelAllowed";
export const SETTINGS_KEY_BOOK_CANCEL_LIMIT_DAY = "bookCancelLimitDay";
export const SETTINGS_KEY_BOOK_CANCEL_LIMIT_HOUR = "bookCancelLimitHour";
export const SETTINGS_KEY_BOOK_CANCEL_LIMIT_MINUTE = "bookCancelLimitMinute";
export const SETTINGS_KEY_BOOK_CANCEL_TEXT = "bookCancelText";
export const SETTINGS_KEY_MEMBER_MESSAGE_RESERVATION =
	"bookRegistrationMessage";
export const SETTINGS_KEY_MEMBER_MESSAGE_CAMPAIGN = "campaignApplyMessage";
export const SETTINGS_KEY_MEMBER_MESSAGE_REMIND1 = "bookRemind1Message";
export const SETTINGS_KEY_MEMBER_MESSAGE_REMIND2 = "bookRemind2Message";
export const SETTINGS_KEY_MEMBER_WINNING_MESSAGE = "winningMessage";
export const SETTINGS_KEY_ADMIN_MESSAGE_MEMBER = "watchMemberTemplate";
export const SETTINGS_KEY_ADMIN_MESSAGE_CAMPAIGN = "watchCampaignApplyTemplate";
export const SETTINGS_KEY_ADMIN_MESSAGE_RESERVATION =
	"watchRegistrationTemplate";
export const SETTINGS_KEY_ADMIN_MESSAGE_RESERVATION_CANCEL =
	"watchRegistrationCancelTemplate";
export const SETTINGS_KEY_BARCODE_ENABLED = "isBarcodeEnabled";
export const SETTINGS_KEY_POINT_ENABLED = "isPointEnabled";
export const SETTINGS_KEY_DATE_OF_EXPIRY_ENABLED = "isDateOfExpiryEnabled";
export const SETTINGS_KEY_SUBSCRIPTION_POINT_ENABLED =
	"subscriptionPointEnabled";
export const SETTINGS_KEY_POINT_GRANT_RATE = "pointGrantRate";
export const SETTINGS_KEY_POINT_CONVERSION_RATE = "pointConversionRate";

/* SETTINGS LABEL */
export const SETTINGS_LABEL_SYSTEM_COLOR = "システム色";
export const SETTINGS_LABEL_SYSTEM_TITLE = "システムタイトル";
export const SETTINGS_LABEL_CLIENT_CATEGORIES_SCREEN_TITLE = "予約画面タイトル";
export const SETTINGS_LABEL_CLIENT_CATEGORIES_SCREEN_SUBTITLE =
	"予約画面サブタイトル";
export const SETTINGS_LABEL_ADMIN_INITIAL_RESERVABLE_COUNT =
	"予約可能人数の初期値";
export const SETTINGS_LABEL_RESERVATION_CONFIRM_URL = "予約確認URL";
export const SETTINGS_LABEL_COMPANY_TELEPHONE = "問い合わせ電話番号";
export const SETTINGS_LABEL_SUBSCRIPTION_POINT_ENABLED =
	"ポイント機能（サブスクリプション決済用）";
export const SETTINGS_LABEL_POINT_GRANT_RATE = "ポイント付与率";
export const SETTINGS_LABEL_POINT_CONVERSION_RATE = "ポイント換算レート";
export const SETTINGS_LABEL_BOOK_LIMIT_ENABLED = "予約限定";
export const SETTINGS_LABEL_BOOK_LIMIT_DAY = "予約限定日数";
export const SETTINGS_LABEL_BOOK_LIMIT_HOUR = "予約限定時";
export const SETTINGS_LABEL_BOOK_LIMIT_MINUTE = "予約限定分";
export const SETTINGS_LABEL_BOOK_CANCEL_ALLOWED = "予約キャンセル可能";
export const SETTINGS_LABEL_BOOK_CANCEL_LIMIT_DAY = "予約キャンセル限定日";
export const SETTINGS_LABEL_BOOK_CANCEL_LIMIT_HOUR = "予約キャンセル限定時";
export const SETTINGS_LABEL_BOOK_CANCEL_LIMIT_MINUTE = "予約キャンセル限定分";
export const SETTINGS_LABEL_BOOK_CANCEL_TEXT = "予約キャンセル説明文";
export const SETTINGS_LABEL_MEMBER_MESSAGE_RESERVATION = "予約メッセージ";
export const SETTINGS_LABEL_MEMBER_MESSAGE_CAMPAIGN =
	"キャンペーン応募メッセージ";
export const SETTINGS_LABEL_MEMBER_MESSAGE_REMIND1 =
	"予約リマインドメッセージ1";
export const SETTINGS_LABEL_MEMBER_MESSAGE_REMIND2 =
	"予約リマインドメッセージ2";
export const SETTINGS_LABEL_MEMBER_WINNING_MESSAGE =
	"当選に配信されるメッセージ";
export const SETTINGS_LABEL_ADMIN_MESSAGE_MEMBER = "新規メンバーメッセージ";
export const SETTINGS_LABEL_ADMIN_MESSAGE_CAMPAIGN =
	"新規キャンペーン応募メッセージ";
export const SETTINGS_LABEL_ADMIN_MESSAGE_RESERVATION = "新規予約メッセージ";
export const SETTINGS_LABEL_ADMIN_MESSAGE_RESERVATION_CANCEL =
	"予約キャンセルメッセージ";

/* SOCKET LABEL */
export const SOCKET_NEW_CUSTOMER = "newCustomer";
export const SOCKET_SYSTEM_SETTING = "systemSetting";
export const SOCKET_UPDATE_CUSTOMER = "updateCustomer";
export const SOCKET_DELETE_CUSTOMER = "deleteCustomer";
export const SOCKET_NEW_INQUIRY = "newInquiry";
export const SOCKET_UPDATE_INQUIRY = "updateInquiry";
export const SOCKET_DELETE_INQUIRY = "deleteInquiry";
export const SOCKET_NEW_MESSAGE = "newMessage";
export const SOCKET_FAVICON = "favicon";
export const SOCKET_LOGO = "logo";
export const SOCKET_STORE_PIC = "storePic";
export const SOCKET_CATEGORY = "category";
export const SOCKET_CAMPAIGN = "campaign";
export const SOCKET_TEMPLATE = "template";
export const SOCKET_OCCASION = "occasion";
export const SOCKET_GIFT = "gift";
export const SOCKET_OCCURRENCE = "occurrence";
export const SOCKET_REGISTRATION = "registration";
export const SOCKET_MEMBER = "member";
export const SOCKET_CHAT = "chat";
export const SOCKET_AUDIENCE = "audience";
export const SOCKET_CUSTOMER_REGISTRATION_CHANGED =
	"customer_registration:changed";

// KEY DATA BY PAGE
export const CLIENT_LOGIN_PAGE = "clientLogin";

/* AXIOS CONFIG */
const axiosInstance = axios.create({
	withCredentials: true,
	baseURL: BASE_URL,
	timeout: 60000,
});

axiosInstance.interceptors.response.use(
	(response) => response,
	(error) => {
		const status = error?.response?.status;
		// console.log("error", error.response.headers);
		if (status === COMMONS.RESPONSE_SERVICE_UNAVAILABLE) {
			const retryAfter = error.response?.headers?.["retry-after"];
			message.error({
				content: COMMONS.ERROR_503_MSG(retryAfter),
				key: COMMONS.MESSAGE_SERVICE_UNAVAILABLE_KEY,
				className: "align-message-icon-top",
			});
			return new Promise(() => {});
		}
		return Promise.reject(error);
	},
);

/* BACKEND API REQUESTS */
export async function ADMIN_LOGIN(data) {
	return await axiosInstance.post(API_ADMIN_LOGIN, data);
}

export async function ADMIN_LOGOUT() {
	return await axiosInstance.get(API_ADMIN_LOGOUT);
}

export async function ADMIN_CHECK_SESSION() {
	return await axiosInstance.get(API_ADMIN_CHECK_SESSION);
}

export async function ADMIN_GET_AUTH() {
	return await axiosInstance.get(API_ADMIN_AUTH);
}

export async function ADMIN_GET_DAILY_STATS(filterStatsFrom, filterStatsTo) {
	const paramData = {
		params: {
			from: filterStatsFrom,
			to: filterStatsTo,
		},
	};

	return await axiosInstance.get(API_ADMIN_DAILY_STATS, paramData);
}

export async function ADMIN_GET_CATEGORY_TEMPLATES() {
	const paramData = {
		params: {
			includeDestroyed: false,
		},
	};

	return await axiosInstance.get(API_ADMIN_CATEGORIES + "/basic", paramData);
}

export async function ADMIN_GET_CATEGORY_TEMPLATE_DETAIL(categoryId) {
	const paramData = {
		params: {
			includeDestroyed: false,
		},
	};

	return await axiosInstance.get(
		API_ADMIN_CATEGORIES + "/" + categoryId,
		paramData,
	);
}

export async function ADMIN_GET_CATEGORY_TAGS() {
	return await axiosInstance.get(API_ADMIN_CATEGORIES + "/tags");
}

export async function ADMIN_GET_CAMPAIGNS_TAGS() {
	return await axiosInstance.get(API_ADMIN_CAMPAIGNS + "/tags");
}

export async function ADMIN_GET_GIFTS_TAGS() {
	return await axiosInstance.get(API_ADMIN_GIFTS + "/tags");
}

export async function ADMIN_GET_CATEGORY_AREAS() {
	return await axiosInstance.get(API_ADMIN_CATEGORIES + "/areas");
}

export async function ADMIN_GET_CATEGORIES({ pageParam = 1 }) {
	const paramData = {
		params: {
			pp: 20,
			p: pageParam,
		},
	};

	return await axiosInstance.get(API_ADMIN_CATEGORIES, paramData);
}
export async function ADMIN_GET_Campaign_CATEGORIES({ pageParam = 1 }) {
	const paramData = {
		params: {
			pp: 20,
			p: pageParam,
			isCampaign: true,
		},
	};

	return await axiosInstance.get(API_ADMIN_CATEGORIES, paramData);
}

export async function ADMIN_GET_CATEGORY_LIST(includePic, includeDestroyed) {
	const paramData = {
		params: {
			includePic: includePic,
			includeDestroyed: includeDestroyed,
		},
	};

	return await axiosInstance.get(API_ADMIN_CATEGORIES + "/basic", paramData);
}

export async function ADMIN_GET_CATEGORY_DETAIL(
	categoryId,
	filterOccurrencesFrom,
	filterOccurrencesTo,
	search,
) {
	const dataSearch = search?.map((item) => item?.toISOString());
	const paramData = {
		params: {
			from: filterOccurrencesFrom,
			to: filterOccurrencesTo,
			search: dataSearch,
		},
	};

	return await axiosInstance.get(
		API_ADMIN_CATEGORIES + "/" + categoryId,
		paramData,
	);
}

export async function ADMIN_GET_CAMPAIGN_DETAIL(
	campaignId,
	filterOccurrencesFrom,
	filterOccurrencesTo,
	search,
) {
	const dataSearch = search?.map((item) => item?.toISOString());
	const paramData = {
		params: {
			from: filterOccurrencesFrom,
			to: filterOccurrencesTo,
			search: dataSearch,
		},
	};

	return await axiosInstance.get(
		API_ADMIN_CAMPAIGNS + "/" + campaignId,
		paramData,
	);
}

export async function ADMIN_CREATE_CATEGORY(data) {
	const headerData = {
		headers: {
			"content-type": "multipart/form-data",
		},
	};

	return await axiosInstance.post(
		API_ADMIN_CATEGORIES,
		data?.formData,
		headerData,
	);
}

export async function ADMIN_GET_CAMPAIGN_TEMPLATES() {
	const paramData = {
		params: {
			includeDestroyed: false,
		},
	};

	return await axiosInstance.get(API_ADMIN_CAMPAIGNS + "/basic", paramData);
}

export async function ADMIN_GET_CAMPAIGN_TEMPLATE_DETAIL(campaignId) {
	const paramData = {
		params: {
			includeDestroyed: false,
		},
	};

	return await axiosInstance.get(
		API_ADMIN_CAMPAIGNS + "/" + campaignId,
		paramData,
	);
}

export async function ADMIN_GET_CAMPAIGNS({ pageParam = 1 }) {
	const paramData = {
		params: {
			pp: 20,
			p: pageParam,
		},
	};

	return await axiosInstance.get(API_ADMIN_CAMPAIGNS, paramData);
}
export async function ADMIN_CREATE_CAMPAIGN(data) {
	const headerData = {
		headers: {
			"content-type": "multipart/form-data",
		},
	};

	return await axiosInstance.post(
		API_ADMIN_CAMPAIGNS,
		data?.formData,
		headerData,
	);
}
export async function ADMIN_UPDATE_CAMPAIGN(data) {
	const headerData = {
		headers: {
			"content-type": "multipart/form-data",
		},
	};

	return await axiosInstance.put(
		API_ADMIN_CAMPAIGNS + "/" + data?.campaignId,
		data?.formData,
		headerData,
	);
}

export async function ADMIN_UPDATE_CATEGORY(data) {
	const headerData = {
		headers: {
			"content-type": "multipart/form-data",
		},
	};

	return await axiosInstance.put(
		API_ADMIN_CATEGORIES + "/" + data?.categoryId,
		data?.formData,
		headerData,
	);
}

export async function ADMIN_UPDATE_CATEGORY_ORDER(data) {
	return await axiosInstance.put(API_ADMIN_CATEGORIES, data);
}

export async function ADMIN_DELETE_CATEGORY(data) {
	return await axiosInstance.delete(
		API_ADMIN_CATEGORIES + "/" + data?.categoryId,
	);
}
export async function ADMIN_DELETE_CAMPAIGN(data) {
	return await axiosInstance.delete(
		API_ADMIN_CAMPAIGNS + "/" + data?.campaignId,
	);
}

export async function ADMIN_GET_OCCASION_TEMPLATES(isCampaign = false) {
	const paramData = {
		params: {
			includeDestroyed: false,
			isCampaign: isCampaign,
		},
	};

	return await axiosInstance.get(API_ADMIN_OCCASIONS + "/basic", paramData);
}

export async function ADMIN_GET_Gift_TEMPLATES() {
	const paramData = {
		params: {
			includeDestroyed: false,
		},
	};

	return await axiosInstance.get(API_ADMIN_GIFTS + "/basic", paramData);
}
export async function ADMIN_GET_GIFT_TEMPLATE_DETAIL(giftId) {
	const paramData = {
		params: {
			includeDestroyed: false,
		},
	};

	return await axiosInstance.get(API_ADMIN_GIFTS + "/" + giftId, paramData);
}

export async function ADMIN_GET_OCCASION_TEMPLATE_DETAIL(occasionId) {
	const paramData = {
		params: {
			includeDestroyed: false,
		},
	};

	return await axiosInstance.get(
		API_ADMIN_OCCASIONS + "/" + occasionId,
		paramData,
	);
}

export async function ADMIN_GET_OCCASIONS({ pageParam = 1, queryKey }) {
	const paramData = {
		params: {
			categoryId: queryKey[1],
			pp: 20,
			p: pageParam,
		},
	};

	return await axiosInstance.get(API_ADMIN_OCCASIONS, paramData);
}
export async function ADMIN_GET_CAMPAIGN_GIFTS({ pageParam = 1, queryKey }) {
	const paramData = {
		params: {
			campaignId: queryKey[1],
			pp: 20,
			p: pageParam,
		},
	};

	return await axiosInstance.get(API_ADMIN_CAMPAIGN_GIFTS, paramData);
}

export async function ADMIN_GET_OCCASION_LIST(includePic, includeDestroyed) {
	const paramData = {
		params: {
			includePic: includePic,
			includeDestroyed: includeDestroyed,
		},
	};

	return await axiosInstance.get(API_ADMIN_OCCASIONS + "/basic", paramData);
}

export async function ADMIN_GET_OCCASION_DETAIL(
	occasionId,
	filterOccurrencesFrom,
	filterOccurrencesTo,
	searchOccasions,
) {
	const dataSearch = searchOccasions?.map((item) => item?.toISOString());
	const paramData = {
		params: {
			from: filterOccurrencesFrom,
			to: filterOccurrencesTo,
			search: dataSearch,
		},
	};

	return await axiosInstance.get(
		API_ADMIN_OCCASIONS + "/" + occasionId,
		paramData,
	);
}

export async function ADMIN_CREATE_OCCASION(data) {
	const headerData = {
		headers: {
			"content-type": "multipart/form-data",
		},
	};

	return await axiosInstance.post(
		API_ADMIN_OCCASIONS,
		data?.formData,
		headerData,
	);
}

export async function ADMIN_UPDATE_OCCASION(data) {
	const headerData = {
		headers: {
			"content-type": "multipart/form-data",
		},
	};

	return await axiosInstance.put(
		API_ADMIN_OCCASIONS + "/" + data?.occasionId,
		data?.formData,
		headerData,
	);
}

export async function ADMIN_CREATE_CAMPAIGN_GIFTS(data) {
	const headerData = {
		headers: {
			"content-type": "multipart/form-data",
		},
	};

	return await axiosInstance.post(
		API_ADMIN_CAMPAIGN_GIFTS,
		data?.formData,
		headerData,
	);
}

export async function ADMIN_UPDATE_CAMPAIGN_GIFTS(data) {
	const headerData = {
		headers: {
			"content-type": "multipart/form-data",
		},
	};

	return await axiosInstance.put(
		API_ADMIN_CAMPAIGN_GIFTS + "/" + data?.giftId,
		data?.formData,
		headerData,
	);
}

export async function ADMIN_UPDATE_OCCASION_ORDER(data) {
	return await axiosInstance.put(API_ADMIN_OCCASIONS, data);
}

export async function ADMIN_UPDATE_GIFT_ORDER(data) {
	return await axiosInstance.put(API_ADMIN_GIFTS, data);
}
export async function ADMIN_UPDATE_GIFT(data) {
	return await axiosInstance.put(API_ADMIN_GIFTS + "/update", { gifts: data });
}
export async function ADMIN_POST_REGISTER_WINNERS(data) {
	return await axiosInstance.post(
		API_ADMIN_CAMPAIGNS + "/register-winners",
		data,
	);
}
export async function ADMIN_POST_AUTOMATIC_REGISTER_WINNERS(data) {
	return await axiosInstance.post(
		API_ADMIN_CAMPAIGNS + "/automatic-register-winners",
		data,
	);
}
export async function ADMIN_RESET_REGISTER_WINNERS(data) {
	return await axiosInstance.post(API_ADMIN_CAMPAIGNS + "/reset-winners", data);
}

export async function ADMIN_DELETE_GIFT(data) {
	return await axiosInstance.delete(API_ADMIN_GIFTS + "/" + data?.giftId);
}
export async function ADMIN_DELETE_OCCASION(data) {
	return await axiosInstance.delete(
		API_ADMIN_OCCASIONS + "/" + data?.occasionId,
	);
}

export async function ADMIN_GET_OCCASION_TAGS() {
	return await axiosInstance.get(API_ADMIN_OCCASIONS + "/tags");
}

export async function ADMIN_CREATE_OCCURRENCE(data) {
	return await axiosInstance.post(API_ADMIN_OCCURRENCES, data);
}

export async function ADMIN_GET_OCCURRENCE_DETAIL(occurrenceId) {
	return await axiosInstance.get(API_ADMIN_OCCURRENCES + "/" + occurrenceId);
}

export async function ADMIN_GET_CAMPAIGN_REGISTRATIONS(campaignId) {
	return await axiosInstance.get(
		API_ADMIN_CAMPAIGN_REGISTRATIONS + "/" + campaignId,
	);
}

export async function ADMIN_UPDATE_OCCURRENCE(data) {
	return await axiosInstance.put(
		API_ADMIN_OCCURRENCES + "/" + data?.occurrenceId,
		data,
	);
}

export async function ADMIN_DELETE_OCCURRENCE(data) {
	return await axiosInstance.delete(
		API_ADMIN_OCCURRENCES + "/" + data?.occurrenceId,
	);
}

export async function ADMIN_DELETE_BATCH_OCCURRENCES(data) {
	return await axiosInstance.delete(API_ADMIN_OCCURRENCES, { data: data });
}

export async function ADMIN_CREATE_REGISTRATION_MANUAL(data) {
	return await axiosInstance.post(API_ADMIN_REGISTRATIONS, data);
}
export async function ADMIN_CREATE_REGISTRATION_CAMPAIGN_MANUAL(data) {
	return await axiosInstance.post(API_ADMIN_CAMPAIGN_REGISTRATIONS, data);
}

export async function ADMIN_UPDATE_REGISTRATION(data) {
	return await axiosInstance.put(API_ADMIN_REGISTRATIONS + "/edit", data);
}

export const MUTATION_KEY_ADMIN_UPDATE_ATTENDED_REGISTRATION =
	"MUTATION_KEY_ADMIN_UPDATE_ATTENDED_REGISTRATION";
export async function ADMIN_UPDATE_ATTENDED_REGISTRATION(data) {
	return await axiosInstance.put(
		API_ADMIN_REGISTRATIONS + "/update-attended",
		data,
	);
}

export async function ADMIN_GET_HISTORY_ATTENDED(numberId) {
	return await axiosInstance
		.get(API_ADMIN_HISTORY_REGISTRATIONS + "/" + numberId)
		.then((res) => res.data);
}

export async function ADMIN_GET_HISTORY_CAMPAIGNS_ATTENDED(numberId) {
	return await axiosInstance
		.get(API_ADMIN_HISTORY_CAMPAIGNS_REGISTRATIONS + "/" + numberId)
		.then((res) => res.data);
}

export async function ADMIN_CANCEL_REGISTRATION(data) {
	const param = {
		data: {},
	};

	return await axiosInstance.delete(
		API_ADMIN_REGISTRATIONS + "/" + data.registrationId + "/cancel",
		param,
	);
}

export const MUTATION_KEY_ADMIN_CONFIRM_REGISTRATION =
	"ADMIN_CONFIRM_REGISTRATION";
export async function ADMIN_CONFIRM_REGISTRATION(data) {
	return await axiosInstance.post(API_ADMIN_REGISTRATIONS + "/qr", data);
}

export async function ADMIN_RECONFIRM_REGISTRATION(data) {
	return await axiosInstance.put(API_ADMIN_REGISTRATIONS + "/confirm", data);
}

export async function ADMIN_EXPORT_REGISTRATIONS(data) {
	return await axiosInstance.post(API_ADMIN_REGISTRATIONS + "/csv", data);
}

export async function ADMIN_GET_MEMBERS(
	paginationPerPage,
	paginationPage,
	paginationSort,
	paginationSortKey,
	filterIsCampaignPage,
	// filterIsCampaign,
	filterName,
	filterTelephone,
	filterEmail,
	filterAddress,
	filterMemberSinceMin,
	filterMemberSinceMax,
	// filterCandidateAtMin,
	// filterCandidateAtMax,
	// filterHasWon,
	filterMemberId,
) {
	const paramData = {
		params: {
			pp: paginationPerPage,
			p: paginationPage,
			sort: paginationSort,
			sortKey: paginationSortKey,
			...(filterIsCampaignPage
				? {
						isCampaign: true,
					}
				: {}),
			name: filterName,
			telephone: filterTelephone,
			email: filterEmail,
			address: filterAddress,
			memberSinceMin: filterMemberSinceMin,
			memberSinceMax: filterMemberSinceMax,
			// candidateAtMin: filterCandidateAtMin,
			// candidateAtMax: filterCandidateAtMax,
			// hasWon: filterHasWon,
			memberId: filterMemberId,
		},
	};

	return await axiosInstance.get(API_ADMIN_MEMBERS, paramData);
}

export async function ADMIN_GET_MEMBER(data) {
	return await axiosInstance.get(API_ADMIN_MEMBERS + "/" + data.memberId);
}

export async function ADMIN_DELETE_MEMBER(data) {
	return await axiosInstance.delete(API_ADMIN_MEMBERS + "/" + data.memberId);
}

export async function ADMIN_RENEW_MEMBER(data) {
	if (data instanceof FormData) {
		return await axiosInstance.put(
			API_ADMIN_MEMBERS + "/" + data.get("memberId"),
			data,
			{
				headers: {
					"content-type": "multipart/form-data",
				},
			},
		);
	} else {
		return await axiosInstance.put(
			API_ADMIN_MEMBERS + "/" + data.memberId,
			data,
		);
	}
}

export async function ADMIN_CHECK_MEMBER(data) {
	return await axiosInstance.get(
		`${API_ADMIN_MEMBERS}/barcode/${encodeURIComponent(data.memberCode)}`,
	);
}

export async function ADMIN_EXPORT_MEMBERS(data) {
	const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	return await axiosInstance.post(API_ADMIN_MEMBERS + "/csv", {
		...data,
		timeZone: clientTimezone,
	});
}

export async function ADMIN_EXPORT_INFLOW_SOURCE(data) {
	return await axiosInstance.post(API_ADMIN_INFLOW_SOURCE + "/csv", data);
}

export async function ADMIN_GET_CHATS(member) {
	return await axiosInstance.get(API_ADMIN_CHATS + "/" + member?.memberId);
}

export async function ADMIN_SEND_CHAT(data) {
	if (data instanceof FormData) {
		return await axiosInstance.post(
			API_ADMIN_CHATS + "/" + data.get("memberId"),
			data,
			{
				headers: {
					"content-type": "multipart/form-data",
				},
			},
		);
	} else {
		return await axiosInstance.post(
			API_ADMIN_CHATS + "/" + data.memberId,
			data,
		);
	}
}

export async function ADMIN_GET_CAMPAIGN_QUESTIONS() {
	const paramData = {
		params: {},
	};

	return await axiosInstance.get(API_ADMIN_CAMPAIGNS + "/questions", paramData);
}

export async function ADMIN_GET_CAMPAIGN_QUESTIONS_NEW({ campaignId }) {
	const paramData = {
		params: {},
	};

	return await axiosInstance.get(
		API_ADMIN_CAMPAIGNS + `/list-questions/${campaignId}`,
		paramData,
	);
}

export async function ADMIN_CREATE_CAMPAIGN_QUESTION(data) {
	return await axiosInstance.post(API_ADMIN_CAMPAIGNS + "/questions", data);
}

export async function ADMIN_CREATE_CAMPAIGN_QUESTION_NEW(data) {
	return await axiosInstance.post(
		API_ADMIN_CAMPAIGNS + "/create-questions",
		data,
	);
}

export async function ADMIN_UPDATE_CAMPAIGN_QUESTION(data) {
	return await axiosInstance.put(
		API_ADMIN_CAMPAIGNS + "/questions/" + data?.questionId,
		data,
	);
}

export async function ADMIN_UPDATE_CAMPAIGN_QUESTION_ORDER(data) {
	return await axiosInstance.put(API_ADMIN_CAMPAIGNS + "/questions", data);
}

export async function ADMIN_DELETE_CAMPAIGN_QUESTION(data) {
	return await axiosInstance.delete(
		API_ADMIN_CAMPAIGNS + "/questions/" + data?.questionId,
	);
}
export async function ADMIN_DELETE_SURVEY(data) {
	return await axiosInstance.delete(API_CLIENT_SURVEYS + "/" + data.surveyId);
}
export async function ADMIN_DELETE_SURVEY_TEMPLATE(data) {
	return await axiosInstance.delete(
		API_CLIENT_ADD_SURVEYS_TEMPLATE + "/" + data.tpId,
	);
}

export async function ADMIN_GET_CAMPAIGN_CANDIDATES(data) {
	return await axiosInstance.get(API_ADMIN_CAMPAIGNS + "/candidates", data);
}

export async function ADMIN_UPDATE_CAMPAIGN_CANDIDATE(data) {
	return await axiosInstance.post(API_ADMIN_CAMPAIGNS + "/winners", data);
}

export async function ADMIN_EXPORT_CAMPAIGN_WINNERS(data) {
	return await axiosInstance.post(API_ADMIN_CAMPAIGNS + "/winners/csv", data);
}

export async function ADMIN_RESET_CAMPAIGN_WINNERS(data) {
	return await axiosInstance.post(API_ADMIN_CAMPAIGNS + "/winners/reset", data);
}

export async function ADMIN_GET_AUDIENCES(type = "default") {
	return await axiosInstance.get(API_ADMIN_AUDIENCES, {
		params: {
			type,
		},
	});
}

export async function ADMIN_GET_CAMPAIGN_AUDIENCES() {
	return await axiosInstance.get(API_ADMIN_CAMPAIGN_AUDIENCES);
}

export function ADMIN_CREATE_AUDIENCE(data) {
	return axiosInstance.post(API_ADMIN_AUDIENCES, data);
}

export async function ADMIN_CREATE_CAMPAIGN_AUDIENCE(data) {
	return await axiosInstance.post(API_ADMIN_CAMPAIGN_AUDIENCES, data);
}

export async function ADMIN_DELETE_AUDIENCE(data) {
	return await axiosInstance.delete(
		API_ADMIN_AUDIENCES + "/" + data.audienceGroupId,
	);
}

export async function ADMIN_SEARCH_AUDIENCE_MEMBERS(data) {
	return await axiosInstance.post(API_ADMIN_AUDIENCES + "/find", data);
}
export async function ADMIN_SEARCH_CAMPAIGN_AUDIENCE_MEMBERS(data) {
	return await axiosInstance.post(API_ADMIN_CAMPAIGN_AUDIENCES + "/find", data);
}

export async function ADMIN_GET_SPECTATORS() {
	const paramData = {
		params: {},
	};

	return await axiosInstance.get(API_ADMIN_SPECTATORS, paramData);
}

export async function ADMIN_GET_SPECTATOR_CANDIDATES() {
	const paramData = {
		params: {},
	};

	return await axiosInstance.get(
		API_ADMIN_SPECTATORS + "/candidates",
		paramData,
	);
}

export async function ADMIN_REMOVE_SPECTATOR(data) {
	return await axiosInstance.delete(
		API_ADMIN_SPECTATORS + "/" + data.spectatorId,
	);
}

export async function ADMIN_ADD_SPECTATOR(data) {
	return await axiosInstance.post(API_ADMIN_SPECTATORS, data);
}

export async function GET_LOGO() {
	return await axiosInstance.get(BASE_URL + "/logo");
}

export async function ADMIN_UPLOAD_LOGO(logo) {
	const headerData = {
		headers: {
			"content-type": "multipart/form-data",
		},
	};

	const formData = new FormData();
	formData.append("picUrl", logo);

	return await axiosInstance.put(BASE_URL + "/m/logo", formData, headerData);
}

export async function GET_FAVICON() {
	return await axiosInstance.get(BASE_URL + "/favicon");
}

export async function ADMIN_UPLOAD_FAVICON(favicon) {
	const headerData = {
		headers: {
			"content-type": "multipart/form-data",
		},
	};

	const formData = new FormData();
	formData.append("picUrl", favicon);

	return await axiosInstance.put(BASE_URL + "/m/favicon", formData, headerData);
}

export async function GET_STORE_PIC() {
	return await axiosInstance.get(BASE_URL + "/store/pic");
}

export async function ADMIN_UPLOAD_STORE_PIC(logo) {
	const headerData = {
		headers: {
			"content-type": "multipart/form-data",
		},
	};

	const formData = new FormData();
	formData.append("picUrl", logo);

	return await axiosInstance.put(
		BASE_URL + "/m/store/pic",
		formData,
		headerData,
	);
}

export async function GET_ADMIN_PUBLIC_SETTINGS() {
	return await axiosInstance.get(BASE_URL + "/m/settings");
}

export async function GET_PUBLIC_SETTINGS() {
	return await axiosInstance.get(BASE_URL + "/settings");
}

export async function ADMIN_UPDATE_SETTINGS_BATCH(data) {
	return await axiosInstance.put(API_ADMIN_SETTINGS, data);
}

export async function ADMIN_UPDATE_PUBLIC_SETTINGS(data) {
	return await axiosInstance.put(API_ADMIN_SETTINGS + "/" + data.key, data);
}
export async function ADMIN_GET_CLIENT_SURVEYS(params) {
	const { data } = await axiosInstance.get(API_ADMIN_APP_SURVEYS, { params });
	return data;
}
export async function ADMIN_GET_CLIENT_SURVEYS_BYID(data) {
	return await axiosInstance.get(API_ADMIN_APP_SURVEYS + "/" + data);
}
export async function CLIENT_GET_SURVEY_BY_ID({ accessToken, surveyId }) {
	const headerData = {
		headers: { "access-token": accessToken },
	};
	return await axiosInstance.get(API_LIFF_SURVEYS + "/" + surveyId, headerData);
}
export async function ADMIN_GET_CLIENT_QUESTION_SURVEYS(data) {
	return await axiosInstance.get(
		API_ADMIN_APP_SURVEY_TEMPLATES + "/quest/" + data,
	);
}
export async function ADMIN_GET_CLIENT_QUESTION_SURVEYS_STATISTICS(data) {
	return await axiosInstance.get(API_ADMIN_APP_STATISTICS + "/" + data);
}
export async function ADMIN_GET_CLIENT_QUESTION_SURVEYS_STATISTICS_ONE(data) {
	return await axiosInstance.get(API_ADMIN_APP_STATISTICS_ONE + "/" + data);
}
export async function ADMIN_GET_CLIENT_CREATE_SURVEYS(data) {
	return await axiosInstance.post(API_ADMIN_APP_SURVEYS, data);
}
export async function ADMIN_GET_CLIENT_UPDATE_SURVEYS(data) {
	return await axiosInstance.put(
		API_ADMIN_APP_SURVEYS + "/" + data.surveyId,
		data,
	);
}
export async function ADMIN_GET_CUSTOMER_REGISTRATIONS(params = {}) {
	return await axiosInstance.get(API_ADMIN_CUSTOMER_REGISTRATION + "s", {
		params,
	});
}
export async function ADMIN_CREATE_CUSTOMER_REGISTRATION(data) {
	return await axiosInstance.post(API_ADMIN_CUSTOMER_REGISTRATION, data);
}
export async function ADMIN_CREATE_TEMPLATE(data) {
	return await axiosInstance.post(API_ADMIN_APP_SURVEY_TEMPLATES, data);
}
export async function ADMIN_UPDATE_TEMPLATE(data) {
	return await axiosInstance.put(
		API_ADMIN_APP_SURVEY_TEMPLATES + "/" + data.tpId,
		data,
	);
}
export async function ADMIN_DELETE_CUSTOMER_REGISTRATION(
	customerRegistrationId,
) {
	return await axiosInstance.delete(
		API_ADMIN_CUSTOMER_REGISTRATION + "/" + customerRegistrationId,
	);
}
export async function ADMIN_UPDATE_CUSTOMER_REGISTRATION(data) {
	return await axiosInstance.put(
		API_ADMIN_CUSTOMER_REGISTRATION + "/" + data?.customerRegistrationId,
		data,
	);
}
export async function ADMIN_UPDATE_CUSTOMER_REGISTRATION_ORDER(data) {
	return await axiosInstance.put(API_ADMIN_CUSTOMER_REGISTRATION + "s", data);
}
export async function ADMIN_UPDATE_SURVEY_TEMPLATE_ORDER(data) {
	return await axiosInstance.put(
		API_ADMIN_APP_SURVEY_TEMPLATES + "/quest/" + data.surveyId,
		data,
	);
}

export async function ADMIN_GET_RICHMENUS() {
	return await axiosInstance.get(API_ADMIN_RICHMENUS);
}

export async function ADMIN_UPDATE_RICHMENU(data) {
	const headerData = {
		headers: {
			"content-type": "multipart/form-data",
		},
	};

	const formData = new FormData();
	Object.keys(data).forEach((key) => {
		formData.append(key, data[key]);
	});

	return await axiosInstance.put(API_ADMIN_RICHMENUS, formData, headerData);
}

export async function ADMIN_UPDATE_RICHMENU_VISIBILITY(data) {
	return await axiosInstance.put(API_ADMIN_RICHMENUS + "/props", data);
}

export async function ADMIN_DELETE_RICHMENU(data) {
	const param = {
		data: {
			type: data.type,
		},
	};

	return await axiosInstance.delete(API_ADMIN_RICHMENUS, param);
}

export async function CLIENT_GET_PERSONAL_INFO(accessToken, inflowSourceId) {
	const headerData = {
		headers: { "access-token": accessToken },
		params: inflowSourceId ? { inflowSourceId } : {},
	};

	return await axiosInstance.get(API_CLIENT + "/personal", headerData);
}

export async function CLIENT_GET_CUSTOMER_REGISTRATIONS(accessToken) {
	const headerData = { headers: { "access-token": accessToken } };

	return await axiosInstance.get(
		API_CLIENT + "/settings-customer-registrations",
		headerData,
	);
}

export async function CLIENT_REGISTER_PROFILE(data) {
	const headerData = {
		headers: {
			"access-token": data?.accessToken,
			"content-type": "multipart/form-data",
		},
	};

	return await axiosInstance.post(
		API_CLIENT + "/personal",
		data?.formData,
		headerData,
	);
}

export async function CLIENT_UPDATE_PROFILE(data) {
	const headerData = {
		headers: {
			"access-token": data?.accessToken,
			"content-type": "multipart/form-data",
		},
	};

	return await axiosInstance.patch(
		API_CLIENT + "/personal",
		data?.formData,
		headerData,
	);
}

export async function CLIENT_SURVEY_RECORD({ accessToken, data }) {
	const headerData = {
		headers: {
			"content-type": "multipart/form-data",
			"access-token": accessToken,
		},
	};

	return await axiosInstance.post(API_LIFF_SURVEY_RECORDS, data, headerData);
}

export const QUERY_KEY_CLIENT_SURVEY_RECORD_CHECK =
	"QUERY_KEY_CLIENT_SURVEY_RECORD_CHECK";
export async function CLIENT_SURVEY_RECORD_CHECK({ accessToken, surveyId }) {
	const headerData = {
		headers: {
			"access-token": accessToken,
		},
	};

	return await axiosInstance.get(
		API_LIFF_SURVEY_RECORDS + `/check/${surveyId}`,
		headerData,
	);
}

// export async function CLIENT_UPDATE_PROFILE(data) {
//   const headerData = {
//     headers: {
//       "access-token": data.accessToken,
//     },
//   }
//
//   return await axiosInstance.post(API_CLIENT + "/personal", data, headerData)
// }

export async function CLIENT_GET_CAMPAIGN_QUESTIONS(accessToken) {
	const headerData = {
		headers: { "access-token": accessToken },
	};

	return await axiosInstance.get(
		API_CLIENT + "/campaigns/questions",
		headerData,
	);
}

export async function CLIENT_GET_CAMPAIGN_QUESTIONS_NEW({
	accessToken,
	campaignId,
}) {
	const headerData = {
		headers: { "access-token": accessToken },
	};

	return await axiosInstance.get(
		API_CLIENT + `/campaigns/questions/${campaignId}`,
		headerData,
	);
}
export async function CLIENT_GET_SURVEY_QUESTIONS_NEW({
	accessToken,
	surveyId,
}) {
	const headerData = {
		headers: { "access-token": accessToken },
	};

	return await axiosInstance.get(
		API_LIFF_SURVEY_TEMPLATES + `/quest/${surveyId}`,
		headerData,
	);
}

export async function CLIENT_GET_SURVEYS_BYID({ accessToken, surveyId }) {
	const headerData = {
		headers: { "access-token": accessToken },
	};
	return await axiosInstance.get(
		API_CLIENT + `/surveys/${surveyId}`,
		headerData,
	);
}

export async function CLIENT_APPLY_CAMPAIGN(data) {
	const headerData = {
		headers: {
			"access-token": data.accessToken,
		},
	};

	return await axiosInstance.post(
		API_CLIENT + "/campaigns/answers",
		data,
		headerData,
	);
}

export async function CLIENT_GET_CATEGORIES({ pageParam = 1, queryKey }) {
	const headerData = {
		headers: { "access-token": queryKey[1] },
		params: {
			pp: 20,
			p: pageParam,
		},
	};

	return await axiosInstance.get(API_CLIENT + "/categories", headerData);
}

export async function CLIENT_GET_CAMPAIGNS({ pageParam = 1, queryKey }) {
	const headerData = {
		headers: { "access-token": queryKey[1] },
		params: {
			pp: 20,
			p: pageParam,
		},
	};

	return await axiosInstance.get(API_CLIENT + "/campaigns", headerData);
}

export async function CLIENT_GET_CATEGORY_DETAIL(accessToken, categoryId) {
	const paramData = {
		headers: { "access-token": accessToken },
		params: {
			from: moment().format("YYYY-MM-DD HH:mm"),
			to: moment()
				.add(1, "month")
				.endOf("month")
				.hours(23)
				.minutes(59)
				.format("YYYY-MM-DD HH:mm"),
		},
	};

	return await axiosInstance.get(
		API_CLIENT + "/categories/" + categoryId,
		paramData,
	);
}

export async function CLIENT_GET_CAMPAIGN_DETAIL(accessToken, campaignId) {
	const paramData = {
		headers: { "access-token": accessToken },
		params: {
			from: moment().format("YYYY-MM-DD HH:mm"),
			to: moment()
				.add(1, "month")
				.endOf("month")
				.hours(23)
				.minutes(59)
				.format("YYYY-MM-DD HH:mm"),
		},
	};

	return await axiosInstance.get(
		API_CLIENT + "/campaigns/" + campaignId,
		paramData,
	);
}

export async function CLIENT_GET_OCCASIONS({ pageParam = 1, queryKey }) {
	const headerData = {
		headers: { "access-token": queryKey[1] },
		params: {
			pp: 20,
			p: pageParam,
			categoryId: queryKey[2],
		},
	};

	return await axiosInstance.get(API_CLIENT + "/occasions", headerData);
}

export async function CLIENT_GET_GIFTS({ pageParam = 1, queryKey }) {
	const headerData = {
		headers: { "access-token": queryKey[1] },
		params: {
			pp: 20,
			p: pageParam,
			campaignId: queryKey[2],
		},
	};

	return await axiosInstance.get(API_CLIENT + "/campaigns-gifts", headerData);
}

export async function CLIENT_GET_OCCASION_DETAIL(accessToken, occasionId) {
	const paramData = {
		headers: { "access-token": accessToken },
		params: {
			from: moment().format("YYYY-MM-DD HH:mm"),
			to: moment()
				.add(1, "month")
				.endOf("month")
				.hours(23)
				.minutes(59)
				.format("YYYY-MM-DD HH:mm"),
		},
	};

	return await axiosInstance.get(
		API_CLIENT + "/occasions/" + occasionId,
		paramData,
	);
}

export async function CLIENT_RESERVE_OCCASION(data) {
	const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	const headerData = {
		headers: {
			"access-token": data.accessToken,
		},
	};

	return await axiosInstance.post(
		API_CLIENT + "/registerForEvent",
		{ ...data, timeZone: clientTimezone },
		headerData,
	);
}

export async function CLIENT_RESERVE_CAMPAIGN_OCCASION(data) {
	const headerData = {
		headers: {
			"access-token": data?.accessToken,
			"content-type": "multipart/form-data",
		},
	};

	return await axiosInstance.post(
		API_CLIENT + "/campaign-registerForEvent",
		data?.formData,
		headerData,
	);
}

export async function CLIENT_GET_MY_REGISTRATIONS(accessToken) {
	const headerData = {
		headers: { "access-token": accessToken },
	};

	return await axiosInstance.get(API_CLIENT + "/registrations", headerData);
}

export async function CLIENT_GET_MY_CAMPAIGN_REGISTRATIONS(accessToken) {
	const headerData = {
		headers: { "access-token": accessToken },
	};

	return await axiosInstance.get(
		API_CLIENT + "/campaigns-registrations",
		headerData,
	);
}

export async function CLIENT_GET_MY_REGISTRATION_DETAIL(
	accessToken,
	registrationId,
) {
	const headerData = {
		headers: { "access-token": accessToken },
	};

	return await axiosInstance.get(
		API_CLIENT + "/registrations/" + registrationId,
		headerData,
	);
}

export async function CLIENT_GET_MY_CAMPAIGN_REGISTRATION_DETAIL(
	accessToken,
	registrationId,
) {
	const headerData = {
		headers: { "access-token": accessToken },
	};

	return await axiosInstance.get(
		API_CLIENT + "/campaign-registrations/" + registrationId,
		headerData,
	);
}

export async function CLIENT_CANCEL_REGISTRATION(data) {
	const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

	const param = {
		headers: { "access-token": data.accessToken },
		data: { timeZone: clientTimezone },
	};

	return await axiosInstance.delete(
		API_CLIENT + "/registrations/" + data.registrationId,
		param,
	);
}

export async function CLIENT_ATTENDED_REGISTRATION(data) {
	return await axiosInstance.put(
		API_CLIENT + "/registrations/update-attended/" + data.registrationId,
		{},
		{
			headers: { "access-token": data.accessToken },
		},
	);
}

export const GET_PUBLIC_HOLIDAYS = async () => {
	return await axios.get(PUBLIC_HOLIDAY_URL);
};

export const GET_ADDRESS_BY_POSTAL_CODE = (postalCode) => {
	const p3 = postalCode.substr(0, 3);

	return fetch(`${POSTAL_CODE_URL}/${p3}.js`)
		.then((response) => response.text())
		.then((text) => text)
		.catch((error) => {});
};

export const QUERY_KEY_MASTER_AUDIENCE_SURVEY =
	"QUERY_KEY_MASTER_AUDIENCE_SURVEY";
const QUERY_URL_MASTER_AUDIENCE_SURVEY = `${BASE_URL}/m/audiences-survey`;
export const browseAudienceSurvey = async () => {
	const res = await axiosInstance.get(QUERY_URL_MASTER_AUDIENCE_SURVEY);
	return res.data;
};

export const QUERY_KEY_MASTER_AUDIENCE_SURVEY_OPTIONS =
	"QUERY_KEY_MASTER_AUDIENCE_SURVEY_OPTIONS";
export const QUERY_URL_MASTER_AUDIENCE_SURVEY_OPTIONS = `${BASE_URL}/m/audiences-survey/survey-options`;
export const browseAudienceSurveyOptions = async () => {
	const res = await axiosInstance.get(QUERY_URL_MASTER_AUDIENCE_SURVEY_OPTIONS);
	return res.data;
};

const QUERY_URL_MASTER_AUDIENCE_QUESTIONS = `${BASE_URL}/m/audiences-survey/questions`;
export const QUERY_KEY_MASTER_AUDIENCE_SURVEY_QUESTIONS =
	"QUERY_KEY_MASTER_AUDIENCE_QUESTIONS";
export const browseAudienceQuestions = async (surveyId) => {
	const res = await axiosInstance.get(QUERY_URL_MASTER_AUDIENCE_QUESTIONS, {
		params: { surveyId },
	});
	return res.data.map(({ options, ...record }) => ({
		...record,
		options: JSON.parse(options),
	}));
};

const MUTATION_URL_MASTER_AUDIENCE_SURVEY_SEARCH = `${BASE_URL}/m/audiences-survey/search`;
export const MUTATION_KEY_MASTER_AUDIENCE_SURVEY_SEARCH =
	"MUTATION_KEY_MASTER_AUDIENCE_SURVEY_SEARCH";
export const searchAudienceSurvey = async (params) => {
	const res = await axiosInstance.get(
		MUTATION_URL_MASTER_AUDIENCE_SURVEY_SEARCH,
		{
			params,
		},
	);
	return res.data;
};

const MUTATION_URL_MASTER_AUDIENCE_SURVEY_CREATE = `${BASE_URL}/m/audiences-survey`;
export const MUTATION_KEY_MASTER_AUDIENCE_SURVEY_CREATE =
	"MUTATION_KEY_MASTER_AUDIENCE_SURVEY_CREATE";
export const createAudienceSurvey = async (data) => {
	const res = await axiosInstance.post(
		MUTATION_URL_MASTER_AUDIENCE_SURVEY_CREATE,
		data,
	);
	return res.data;
};

const MUTATION_URL_MASTER_AUDIENCE_SURVEY_DELETE = `${BASE_URL}/m/audiences-survey`;
export const MUTATION_KEY_MASTER_AUDIENCE_SURVEY_DELETE =
	"MUTATION_KEY_MASTER_AUDIENCE_SURVEY_DELETE";
export const deleteAudienceSurvey = async (data) => {
	const res = await axiosInstance.delete(
		`${MUTATION_URL_MASTER_AUDIENCE_SURVEY_DELETE}/${data.audienceGroupId}`,
	);
	return res.data;
};

const MUTATION_URL_MASTER_SURVEY_CREATE = `${BASE_URL}/app/surveys`;

export const MUTATION_KEY_MASTER_SURVEY_CREATE =
	"MUTATION_KEY_MASTER_SURVEY_CREATE";

export async function masterCreateSurvey(data) {
	const config = {
		headers: {
			"content-type": "multipart/form-data",
		},
	};
	return axiosInstance.post(MUTATION_URL_MASTER_SURVEY_CREATE, data, config);
}

const MUTATION_URL_MASTER_SURVEY_UPDATE = `${BASE_URL}/app/surveys`;
export const MUTATION_KEY_MASTER_SURVEY_UPDATE =
	"MUTATION_KEY_MASTER_SURVEY_UPDATE";
export async function masterUpdateSurvey(data) {
	return await axiosInstance.put(
		`${MUTATION_URL_MASTER_SURVEY_UPDATE}/${data.surveyId}`,
		data,
	);
}

const QUERY_URL_MASTER_SURVEY_DETAIL = `${BASE_URL}/m/surveys/:surveyId`;
export const QUERY_KEY_MASTER_SURVEY_DETAIL = "QUERY_KEY_MASTER_SURVEY_DETAIL";
export async function masterDetailSurvey(surveyId) {
	const { data } = await axiosInstance.get(
		QUERY_URL_MASTER_SURVEY_DETAIL.replace(":surveyId", surveyId),
	);
	return data;
}

export const MUTATION_KEY_MASTER_SURVEY_EDIT =
	"MUTATION_KEY_MASTER_SURVEY_EDIT";
export async function masterEditSurvey(surveyId, data) {
	const config = {
		headers: {
			"content-type": "multipart/form-data",
		},
	};
	return axiosInstance.patch(
		QUERY_URL_MASTER_SURVEY_DETAIL.replace(":surveyId", surveyId),
		data,
		config,
	);
}

export const MUTATION_KEY_MASTER_SURVEY_DELETE =
	"MUTATION_KEY_MASTER_SURVEY_DELETE";
export async function masterDeleteSurvey(surveyId, data) {
	return axiosInstance.delete(
		QUERY_URL_MASTER_SURVEY_DETAIL.replace(":surveyId", surveyId),
		data,
	);
}

const QUERY_URL_MASTER_SURVEY_STATISTICS = `${BASE_URL}/m/surveys/:surveyId/statistics`;
export const QUERY_KEY_MASTER_SURVEY_STATISTICS =
	"QUERY_KEY_MASTER_SURVEY_STATISTICS";
export async function masterSurveyStatistics(surveyId) {
	const { data } = await axiosInstance.get(
		QUERY_URL_MASTER_SURVEY_STATISTICS.replace(":surveyId", surveyId),
	);
	return data;
}

const MUTATION_URL_MASTER_SURVEY_STATISTICS_EXPORT = `${BASE_URL}/m/surveys/:surveyId/statistics/export`;
export const MUTATION_KEY_MASTER_SURVEY_STATISTICS_EXPORT =
	"MUTATION_KEY_MASTER_SURVEY_EXPORT_CSV";
export async function masterSurveyStatisticsExport(surveyId) {
	return axiosInstance.get(
		MUTATION_URL_MASTER_SURVEY_STATISTICS_EXPORT.replace(":surveyId", surveyId),
	);
}

const MUTATION_URL_MASTER_REGISTRATION_CONFIRMATION = `${BASE_URL}/m/registrations/:registrationId/confirmation`;
export const MUTATION_KEY_MASTER_REGISTRATION_CONFIRMATION =
	"MUTATION_KEY_MASTER_REGISTRATION_CONFIRMATION";
export async function masterRegistrationConfirmation({
	registrationId,
	...data
}) {
	return axiosInstance.post(
		MUTATION_URL_MASTER_REGISTRATION_CONFIRMATION.replace(
			":registrationId",
			registrationId,
		),
		data,
	);
}

const MUTATION_URL_MASTER_UPDATE_COUNT_REGISTRATION = `${BASE_URL}/m/registrations/:registrationId/edit`;
export const MUTATION_KEY_MASTER_UPDATE_COUNT_REGISTRATION =
	"MUTATION_KEY_MASTER_UPDATE_COUNT_REGISTRATION";
export async function masterUpdateCountRegistration({
	registrationId,
	...data
}) {
	return axiosInstance.put(
		MUTATION_URL_MASTER_UPDATE_COUNT_REGISTRATION.replace(
			":registrationId",
			registrationId,
		),
		data,
	);
}

const API_ADMIN_INQUIRIES = BASE_URL + "/m/inquiries";
export const QUERY_KEY_ADMIN_CUSTOMERS_LIST = "ADMIN_CUSTOMERS_LIST";
export async function ADMIN_CREATE_INQUIRY(data) {
	return await axiosInstance.post(API_ADMIN_INQUIRIES, data);
}

const API_ADMIN_CUSTOMERS = BASE_URL + "/m/customers";
export const QUERY_KEY_ADMIN_INQUIRIES = "ADMIN_INQUIRIES";
export async function ADMIN_GET_CUSTOMERS_LIST() {
	return await axiosInstance.get(API_ADMIN_CUSTOMERS + "/list");
}

export async function ADMIN_UPDATE_INQUIRY(data) {
	return await axiosInstance.put(
		API_ADMIN_INQUIRIES + "/" + data?.inquiryId,
		data,
	);
}

export async function ADMIN_DELETE_INQUIRY(data) {
	return await axiosInstance.delete(
		API_ADMIN_INQUIRIES + "/" + data?.inquiryId,
	);
}

export async function ADMIN_GET_INQUIRIES(
	paginationPerPage,
	paginationPage,
	paginationSort,
	paginationSortKey,
	filterName,
	filterNameKana,
	filterTelephone,
	filterEmail,
	filterCompany,
	filterType,
	filterStatus,
	filterNote,
) {
	const paramData = {
		params: {
			pp: paginationPerPage,
			p: paginationPage,
			sort: paginationSort,
			sortKey: paginationSortKey,
			fullName: filterName,
			furiganaName: filterNameKana,
			telephone: filterTelephone,
			email: filterEmail,
			companyName: filterCompany,
			inquiryType: filterType,
			inquiryStatus: filterStatus,
			notes: filterNote,
		},
	};

	return await axiosInstance.get(API_ADMIN_INQUIRIES, paramData);
}

export const QUERY_KEY_ADMIN_CUSTOMERS = "ADMIN_CUSTOMERS";
export async function ADMIN_GET_CUSTOMERS(
	paginationPerPage,
	paginationPage,
	paginationSort,
	paginationSortKey,
	filterName,
	filterNameKana,
	filterTelephone,
	filterEmail,
	filterCompany,
	filterVia,
	filterNote,
) {
	const paramData = {
		params: {
			pp: paginationPerPage,
			p: paginationPage,
			sort: paginationSort,
			sortKey: paginationSortKey,
			fullName: filterName,
			furiganaName: filterNameKana,
			telephone: filterTelephone,
			email: filterEmail,
			companyName: filterCompany,
			via: filterVia,
			notes: filterNote,
		},
	};

	return await axiosInstance.get(API_ADMIN_CUSTOMERS, paramData);
}

export async function ADMIN_CREATE_CUSTOMER(data) {
	return await axiosInstance.post(API_ADMIN_CUSTOMERS, data);
}

export async function ADMIN_UPDATE_CUSTOMER(data) {
	return await axiosInstance.put(
		API_ADMIN_CUSTOMERS + "/" + data?.customerId,
		data,
	);
}

export async function ADMIN_DELETE_CUSTOMER(data) {
	return await axiosInstance.delete(
		API_ADMIN_CUSTOMERS + "/" + data?.customerId,
	);
}

export const API_ADMIN_LOTTERIES = BASE_URL + "/m/lotteries";

export async function ADMIN_GET_LOTTERIES({ pageParam = 1, queryKey }) {
	const paramData = {
		params: {
			pp: 20,
			p: pageParam,
		},
	};

	return await axiosInstance.get(API_ADMIN_LOTTERIES, paramData);
}

export async function ADMIN_CREATE_LOTTERY(data) {
	const config = {
		headers: {
			"content-type": "multipart/form-data",
		},
	};

	return await axiosInstance.post(API_ADMIN_LOTTERIES, data?.formData, config);
}

export async function ADMIN_UPDATE_LOTTERY(data) {
	const config = {
		headers: {
			"content-type": "multipart/form-data",
		},
	};

	return await axiosInstance.put(
		API_ADMIN_LOTTERIES + "/" + data?.lotteryId,
		data?.formData,
		config,
	);
}

export async function ADMIN_DELETE_LOTTERY(data) {
	return await axiosInstance.delete(
		API_ADMIN_LOTTERIES + "/" + data?.lotteryId,
	);
}

export async function ADMIN_GET_LOTTERY_DETAIL(lotteryId) {
	return await axiosInstance.get(API_ADMIN_LOTTERIES + "/" + lotteryId);
}

export async function ADMIN_GET_LOTTERY_WINNERS(
	paginationPerPage,
	paginationPage,
	paginationSort,
	paginationSortKey,
	lotteryId,
) {
	const paramData = {
		params: {
			pp: paginationPerPage,
			p: paginationPage,
			sort: paginationSort,
			sortKey: paginationSortKey,
		},
	};

	return await axiosInstance.get(
		API_ADMIN_LOTTERIES + "/" + lotteryId + "/winners",
		paramData,
	);
}

export async function ADMIN_GET_LOTTERY_PRIZES(
	paginationPerPage,
	paginationPage,
	paginationSort,
	paginationSortKey,
	lotteryId,
) {
	const paramData = {
		params: {
			pp: paginationPerPage,
			p: paginationPage,
			sort: paginationSort,
			sortKey: paginationSortKey,
		},
	};

	return await axiosInstance.get(
		API_ADMIN_LOTTERIES + "/" + lotteryId + "/prizes",
		paramData,
	);
}

export async function ADMIN_CREATE_LOTTERY_PRIZE(data) {
	const config = {
		headers: {
			"content-type": "multipart/form-data",
		},
	};

	return await axiosInstance.post(
		API_ADMIN_LOTTERIES + "/" + data?.lotteryId + "/prizes",
		data.formData,
		config,
	);
}

export async function ADMIN_UPDATE_LOTTERY_PRIZE(data) {
	const config = {
		headers: {
			"content-type": "multipart/form-data",
		},
	};

	return await axiosInstance.put(
		API_ADMIN_LOTTERIES + "/" + data?.lotteryId + "/prizes/" + data?.prizeId,
		data.formData,
		config,
	);
}

export async function ADMIN_DELETE_LOTTERY_PRIZE(data) {
	return await axiosInstance.delete(
		API_ADMIN_LOTTERIES + "/" + data?.lotteryId + "/prizes/" + data?.prizeId,
	);
}

export async function ADMIN_DELETE_LOTTERY_DRAW(data) {
	return await axiosInstance.delete(
		API_ADMIN_LOTTERIES + "/" + data?.lotteryId + "/draws/" + data?.drawId,
	);
}

export const QUERY_KEY_ADMIN_COUPONS = "ADMIN_COUPONS";
export const QUERY_KEY_ADMIN_COUPONS_LIST = "ADMIN_COUPONS_LIST";
export const QUERY_KEY_ADMIN_LOTTERIES = "ADMIN_LOTTERIES";
export const QUERY_KEY_ADMIN_LOTTERY_DETAIL = "ADMIN_LOTTERY_DETAIL";
export const QUERY_KEY_ADMIN_LOTTERY_WINNERS = "ADMIN_LOTTERY_WINNERS";
export const QUERY_KEY_ADMIN_LOTTERY_PRIZES = "ADMIN_LOTTERY_PRIZES";
export const QUERY_KEY_ADMIN_NOTIFICATIONS = "ADMIN_NOTIFICATIONS";
export const QUERY_KEY_ADMIN_TEMPLATES_LIST = "ADMIN_TEMPLATES_LIST";
export const QUERY_KEY_CLIENT_INQUIRIES = "CLIENT_INQUIRIES";
export const QUERY_KEY_CLIENT_LOTTERIES = "CLIENT_LOTTERIES";
export const QUERY_KEY_CLIENT_LOTTERY_DETAIL = "CLIENT_LOTTERY_DETAIL";

export const API_ADMIN_COUPONS = BASE_URL + "/m/coupons";
export async function ADMIN_GET_COUPONS({ pageParam = 1, queryKey }) {
	const paramData = {
		params: {
			pp: 20,
			p: pageParam,
		},
	};

	return await axiosInstance.get(API_ADMIN_COUPONS, paramData);
}

export async function ADMIN_GET_COUPONS_LIST() {
	return await axiosInstance.get(API_ADMIN_COUPONS + "/list");
}

export async function ADMIN_CREATE_COUPON(data) {
	const config = {
		headers: {
			"content-type": "multipart/form-data",
		},
	};

	return await axiosInstance.post(API_ADMIN_COUPONS, data?.formData, config);
}

export async function ADMIN_UPDATE_COUPON(data) {
	const config = {
		headers: {
			"content-type": "multipart/form-data",
		},
	};

	return await axiosInstance.put(
		API_ADMIN_COUPONS + "/" + data?.couponId,
		data?.formData,
		config,
	);
}

export async function ADMIN_DELETE_COUPON(data) {
	return await axiosInstance.delete(API_ADMIN_COUPONS + "/" + data?.couponId);
}

export async function CLIENT_GET_LOTTERY_DETAIL(accessToken, lotteryId) {
	const headerData = { headers: { "access-token": accessToken } };

	return await axiosInstance.get(
		API_CLIENT + "/lotteries/" + lotteryId,
		headerData,
	);
}

export async function CLIENT_DRAW_LOTTERY(data) {
	const headerData = {
		headers: { "access-token": data?.accessToken },
	};

	return await axiosInstance.post(
		API_CLIENT + "/lotteries/" + data?.lotteryId,
		{},
		headerData,
	);
}

export async function CLIENT_GET_LOTTERIES(accessToken) {
	const headerData = { headers: { "access-token": accessToken } };

	return await axiosInstance.get(API_CLIENT + "/lotteries", headerData);
}
export async function ADMIN_SEARCH_CAMPAIGN_LOTTERIES(data) {
	return await axiosInstance.post(API_ADMIN_CAMPAIGN_LOTTERIES, data);
}

const QUERY_URL_MASTER_BROWSE_LOTTERY_AUDIENCE_LOTTERIES = `${API_ADMIN_AUDIENCES}/lotteries`;
export const QUERY_KEY_MASTER_BROWSE_LOTTERY_AUDIENCE_LOTTERIES =
	"QUERY_KEY_MASTER_BROWSE_LOTTERY_AUDIENCE_LOTTERIES";
export async function browseLotteryAudienceLotteries() {
	return axiosInstance.get(QUERY_URL_MASTER_BROWSE_LOTTERY_AUDIENCE_LOTTERIES);
}

const QUERY_URL_MASTER_BROWSE_AUDIENCE_LOTTERY_PRIZES = `${API_ADMIN_AUDIENCES}/lotteries/:lotteryId/prizes`;
export const QUERY_KEY_MASTER_BROWSE_AUDIENCE_LOTTERY_PRIZES =
	"QUERY_KEY_MASTER_BROWSE_AUDIENCE_LOTTERY_PRIZES";
export const browseAudienceLotteryPrizes = async (lotteryId) => {
	return axiosInstance.get(
		QUERY_URL_MASTER_BROWSE_AUDIENCE_LOTTERY_PRIZES.replace(
			":lotteryId",
			lotteryId,
		),
	);
};

const MUTATION_URL_MASTER_BROWSE_AUDIENCE_LOTTERY_DRAWS = `${API_ADMIN_AUDIENCES}/lotteries/:lotteryId/draws`;
export const MUTATION_KEY_MASTER_BROWSE_AUDIENCE_LOTTERY_DRAWS =
	"MUTATION_KEY_MASTER_BROWSE_AUDIENCE_LOTTERY_DRAWS";
export const browseAudienceLotteryDraws = async ({ lotteryId, ...params }) => {
	return axiosInstance.get(
		MUTATION_URL_MASTER_BROWSE_AUDIENCE_LOTTERY_DRAWS.replace(
			":lotteryId",
			lotteryId,
		),
		{
			params,
		},
	);
};

const MUTATION_URL_MASTER_CREATE_AUDIENCE_LOTTERY = `${API_ADMIN_AUDIENCES}/lotteries`;
export const MUTATION_KEY_MASTER_CREATE_AUDIENCE_LOTTERY =
	"MUTATION_KEY_MASTER_CREATE_AUDIENCE_LOTTERY";
export const createAudienceLottery = async (data) => {
	return axiosInstance.post(MUTATION_URL_MASTER_CREATE_AUDIENCE_LOTTERY, data);
};

export const QUERY_KEY_MASTER_ADMIN_GET_LOTTERY_AUDIENCES =
	"QUERY_KEY_MASTER_ADMIN_GET_LOTTERY_AUDIENCES";

const QUERY_URL_MASTER_ADMIN_BROWSE_PRIZES = `${BASE_URL}/m/prizes`;
export const QUERY_KEY_MASTER_ADMIN_BROWSE_PRIZES =
	"QUERY_KEY_MASTER_ADMIN_BROWSE_PRIZES";
export function browsePrizes() {
	return axiosInstance.get(QUERY_URL_MASTER_ADMIN_BROWSE_PRIZES);
}

export const GET_ZIP_CODE_DATA = async (zipcode) => {
	return await axios.get(ZIP_CLOUD_SEARCH_URL, {
		params: { zipcode },
	});
};

export const MUTATION_KEY_MASTER_UPLOAD_SURVEY_QUESTION_IMAGE =
	"MUTATION_KEY_MASTER_UPLOAD_SURVEY_QUESTION_IMAGE";

export async function masterUploadSurveyQuestionImage(data) {
	const config = {
		headers: {
			"content-type": "multipart/form-data",
		},
	};
	return axiosInstance.post(
		`${BASE_URL}/m/upload-survey-question-image`,
		data,
		config,
	);
}

export const MUTATION_KEY_MASTER_REMOVE_SURVEY_QUESTION_IMAGE =
	"MUTATION_KEY_MASTER_REMOVE_SURVEY_QUESTION_IMAGE";

export async function ADMIN_GET_LINEWORKS_USERS() {
	return await axiosInstance.get("/m/lineworks/users");
}

export async function masterRemoveSurveyQuestionImage(data) {
	return axiosInstance.post(`${BASE_URL}/m/remove-survey-question-image`, data);
}

export async function CLIENT_GET_PAYMENT_KEY(data, token) {
	return await axiosInstance.post(API_CLIENT_VERITRANS_PAYMENT_KEY, data, {
		headers: { "access-token": token },
	});
}

export async function CLIENT_REGISTER_PAYMENT_GROUP(data, token) {
	return await axiosInstance.post(API_CLIENT_VERITRANS_REGISTER_GROUP, data, {
		headers: { "access-token": token },
	});
}

export const QUERY_KEY_ADMIN_SUBSCRIPTIONS = "ADMIN_SUBSCRIPTIONS";

export async function ADMIN_GET_SUBSCRIPTIONS() {
	return await axiosInstance.get(BASE_URL + "/m/subscriptions");
}

export async function ADMIN_CANCEL_SUBSCRIPTION(subscriptionId) {
	return await axiosInstance.delete(
		BASE_URL + `/m/subscriptions/${subscriptionId}/cancel`,
	);
}

export async function CLIENT_CANCEL_SUBSCRIPTION(subscriptionId, token) {
	return await axiosInstance.delete(
		`${BASE_URL}/liff/subscriptions/${subscriptionId}/cancel`,
		{
			headers: { "access-token": token },
		},
	);
}

export async function CLIENT_GET_PURCHASE_OCCURRENCES({ accessToken, occurrenceId }) {
	return await axiosInstance.get(
		`${API_CLIENT}/occurrences/${occurrenceId}/purchase`,
		{
			headers: { "access-token": accessToken },
		},
	);
}
